package org.hs_soft.runmynesto.pages.home.sub_page.product.component.tabs.product_general_tab.component

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.margin
import org.hs_soft.runmynesto.domain.config.Dimen

import org.hs_soft.runmynesto.domain.model.general.WindowSizeModeEnum
import org.hs_soft.runmynesto.domain.model.home.product.product_item_model.GetProduct
import org.hs_soft.runmynesto.domain.util.helper.Strings
import org.hs_soft.runmynesto.pages.components.MediumContentTitle

@Composable
fun ProductPriceContent(
    windowSizeMode: WindowSizeModeEnum,
    selectedProduct: GetProduct?,
    profileCountryId: String,
    selectedVat: String?,
    selectedVat2: String?,
    priceLevels: List<String?>?,
    updatePrice: (List<Double?>) -> Unit,
    updatePriceInCafe: (List<Double?>) -> Unit,
    updateVatCode: (String) -> Unit,
    updateVatCode2: (String) -> Unit,
) {
    Column(
        modifier = Modifier
            .margin(top = Dimen.largePadding)
    )
    {
        MediumContentTitle(
            title =Strings.current().prices ,
            marginBottom = Dimen.extraSmallPadding,
        )

        Column(
            modifier = Modifier ,
            horizontalAlignment = Alignment.Start
        )
        {
            Price(
                price =selectedProduct?.price,
                priceLevels=priceLevels,
                selectedVat = selectedVat,
                windowSizeMode = windowSizeMode,
                countryId = profileCountryId,
                updatePrice = {
                    updatePrice(it)
                },
                updateVatCode = {
                    updateVatCode(it)
                }
            )

            PriceInCafe(
                selectedVat2 = selectedVat2,
                priceLevels=priceLevels,
                windowSizeMode =windowSizeMode,
                priceInCafe = selectedProduct?.priceInCafe,
                countryId = profileCountryId,
                updatePriceInCafe = {
                    updatePriceInCafe(it)
                },
                updateVatCode2 = {
                    updateVatCode2(it)
                }
            )

        }

    }
}